import { apiGet, buildApiURL } from '@src/services/api';

const getJobAid = (id) => {
    return apiGet(buildApiURL(`/api/v1/job_aids/${id}`));
};

const getJobAids = (search) => {
    return apiGet(buildApiURL('/api/v1/job_aids', search));
};

export {
    getJobAid,
    getJobAids,
};
